import React from "react";
import FinDocListPage from "../components/FinDocListPage";
import { queryArchivedFinDoc } from "../newApi/findoc.api";

export default function FinDocArchived() {
  return (
    <FinDocListPage
      title="已歸檔"
      menuKey="FinDocArchived"
      defaultStatuses={["done"]}
      fetcher={queryArchivedFinDoc}
      getActions={(record, actor, navigate) => [
        {
          label: "檢視",
          onClick: () => navigate(`/FinDoc/View/${record.findoc_no}`),
        },
      ]}
    />
  );
}